import { request } from "./request";

/** 技师列表 */
export function listTechnicians() {
  return request("/chair/listTechnicians", {
    method: "GET",
  });
}

export function listTechniciansSimple() {
  return request("/chair/listTechniciansSimple", {
    method: "GET",
  });
}

export function addTechnicianInfo(data) {
  return request("/chair/addTechnicianInfo", {
    method: "POST",
    body: {
      workerId: data.workerId,
      realName: data.realName,
      phone: data.phone,
      sex: Number(data.sex),
      region: data.region,
      sitePositioning: data.sitePositioning,
      projectIds: (data.projectIds || []).map((id) => String(id)),
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
    },
  });
}

export function updateTechnicianInfo(data) {
  return request("/chair/updateTechnicianInfo", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      workerId: data.workerId,
      realName: data.realName,
      phone: data.phone,
      sex: Number(data.sex),
      region: data.region,
      sitePositioning: data.sitePositioning,
      projectIds: (data.projectIds || []).map((id) => String(id)),
      deviceIds: (data.deviceIds || []).map((id) => String(id)),
    },
  });
}

export function deleteTechnicianInfo(data) {
  return request("/chair/deleteTechnicianInfo", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
    },
  });
}


export function relateClinicCodes(data) {
  return request("/chair/relateClinicCodes", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      hospitalCode: String(data.hospitalCode ?? "").trim(),
    },
  });
}

export function deleteTechnicianClinicCode(data) {
  return request("/chair/deleteTechnicianClinicCode", {
    method: "POST",
    body: {
      chairId: String(data.chairId),
      hospitalCode: String(data.hospitalCode).trim(),
    },
  });
}
